import { useQuery } from "@tanstack/react-query";
import axios, { AxiosError } from "axios";

import { ApiError } from "@/shared/lib/errors";

// "Notes for Owner" free-text updates, copied verbatim from the cashflow
// workbook's Notes tab (column A, rows 3+).
const cashflowApi = axios.create({
  baseURL: `${String(import.meta.env.VITE_CORE_API_URL)}/cashflow`,
});

interface OwnerNotesApiResponse {
  success: boolean;
  message?: string;
  data?: { notes: string[] };
}

const getOwnerNotes = async (): Promise<string[]> => {
  try {
    const response = await cashflowApi.get<OwnerNotesApiResponse>("/notes", {
      withCredentials: true,
    });
    if (!response.data.success) {
      throw new Error(response.data.message);
    }
    return response.data.data?.notes ?? [];
  } catch (err) {
    if (err instanceof AxiosError) {
      throw new ApiError(err);
    }
    throw err;
  }
};

export const ownerNotesKeys = {
  all: ["cashflow", "owner-notes"] as const,
};

export function useOwnerNotesQuery(enabled = true) {
  return useQuery({
    queryKey: ownerNotesKeys.all,
    queryFn: getOwnerNotes,
    enabled,
    staleTime: 5 * 60 * 1000,
  });
}
